// extracted by mini-css-extract-plugin
module.exports = {"cutstomer_table_header":"ManageCustomers_cutstomer_table_header__Kabuf","background_div":"ManageCustomers_background_div__3-HSw"};